import GuessHelpers from "../../components/Nursery/GeneralAwareness/GuessHelpers";
import MatchHelpers from "../../components/Nursery/GeneralAwareness/MatchHelpers";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

document.title = "Mamas Guidance - Nursery - General Awareness - Community Helper"; // Set page title

const topics: MenuItem[] = [
    // { url: "/nursery/general-awareness/people-help-us/match-community-helper", title: "Match Community Helper", component: MatchHelpers},
    { url: "/nursery/general-awareness/people-help-us/guess-community-helper", title: "Guess Community Helper", component: GuessHelpers},
];


export default topics;